module.exports = __webpack_public_path__ + "img/undraw-switches.b8dc29a0.svg";